import type { DeviceDto } from '@onig-control/contracts';
import { StatusBadge } from './components';

export function DeviceStockStatus({ status }: { status: DeviceDto['status'] }) {
  return status === 'ACTIVE' ? (
    <span className="badge bg-emerald-50 text-emerald-700">Im Bestand</span>
  ) : (
    <StatusBadge status={status} />
  );
}

export function DeviceDeskAccess({
  reports,
  detail = false,
}: {
  reports: DeviceDto['deviceDesk'];
  detail?: boolean;
}) {
  if (!reports?.length) return null;
  const revoked = reports.filter((report) => report.accessStatus === 'REVOKED');
  const unknown = reports.some((report) => report.accessStatus === 'UNKNOWN');
  return (
    <div className={detail ? 'space-y-1' : 'mt-1'}>
      <span
        className={`badge ${revoked.length ? 'bg-red-50 text-red-700' : unknown ? 'bg-amber-50 text-amber-800' : 'bg-slate-100 text-slate-600'}`}
      >
        DeviceDesk:{' '}
        {revoked.length
          ? 'Widerrufen'
          : unknown
            ? 'Zugriffsstatus ausstehend'
            : 'Zugriff nicht widerrufen'}
      </span>
      {detail &&
        revoked.map((report) => (
          <p className="text-sm text-red-700" key={report.integrationInstanceId}>
            Zugriff widerrufen am{' '}
            {report.revokedAt
              ? new Date(report.revokedAt).toLocaleString('de-DE')
              : 'unbekannten Zeitpunkt'}
            . Eine Anwendungsfreigabe hebt den Widerruf nicht auf.
          </p>
        ))}
    </div>
  );
}
